// extracted by mini-css-extract-plugin
export default {"container":"ColorectalCancerScreening_container__7DEPM","back-btn":"ColorectalCancerScreening_back-btn__tqvZv","back-icon":"ColorectalCancerScreening_back-icon__oO+LA"};